import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate, accBankTypes, convertDateFrom } from '../../../appconfig/Settings';

import { AccountTabs } from '../AccountTabs';
import { ListJVEntryValidate } from '../../../config/Validate';
import { getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { DOWNLOADJVENTRY, GETJVENTRY } from '../../../config/ApiConstant';
import { JVEntryListColumns } from '../../../appconfig/DatatableSetting';
import { creditTemplate, debitTemplate, remarkTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { amountFormate } from '../../../appconfig/AppHelper';

export const JVEntry = () => {
    document.title = 'JV Entry | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [year, setYear] = useState<any>(null);
    const [voucher, setVoucher] = useState<any>(null);
    const [jvEntryList, setJVEntryList] = useState<any>([]);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [downloadLoader, setDownloadLoader] = useState<boolean>(false);
    const [credit, setCredit] = useState<any>(0);
    const [debit, setDebit] = useState<any>(0);
    const [errors, setErrors] = useState<any>({});

    // On show click
    const onShowClick = async () => {
        try {
            const { errors, isError } = ListJVEntryValidate(year, voucher);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setPageLoad(false);
                setShowLoader(true);

                const response = await getAllDetailsDirect(GETJVENTRY + '?date=' + year + '&RefNo=' + voucher);
                if (response) {
                    setPageLoad(true);
                    setShowLoader(false);
                    setJVEntryList(response.List);
                    setCredit(response.credit);
                    setDebit(response.dabit);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Download JV Entry
    const downloadJVEntry = async () => {
        try {
            setDownloadLoader(true);

            let formData: any = new FormData();
            formData.append('date', year);
            formData.append('RefNo', voucher);

            const response = await postAllData(DOWNLOADJVENTRY, formData);

            //Check response and download
            if (response) {
                setDownloadLoader(false);

                const link = document.createElement('a');
                link.href = response.url;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setDownloadLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <InputText value={year} name="year" autoComplete="off" placeholder="Enter Year" onChange={(e) => setYear(e.target.value)} className={errors['year'] && 'p-invalid'} />
                    <small className="p-invalid-txt">{errors['year']}</small>
                </div>
                <div className="ml-2">
                    <InputNumber value={voucher} name="voucher" useGrouping={false} placeholder="Enter Voucher No." onChange={(e) => setVoucher(e.value)} className={errors['voucher'] && 'p-invalid'} />
                    <small className="p-invalid-txt">{errors['voucher']}</small>
                </div>
                <Button label="Show" onClick={() => onShowClick()} className="ml-2" loading={showLoader} />
                <Button icon={'pi pi-download'} label="Download" onClick={() => downloadJVEntry()} className="p-button-info ml-2" loading={downloadLoader} disabled={jvEntryList.length > 0 ? false : true} />
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Add JV Entry" icon="pi pi-plus" onClick={() => navigate('/app/account/add-jv-entry')} className="ml-2"></Button>
            </>
        );
    };

    // Datatable footer group
    const footerGroup = () => {
        return jvEntryList.length > 0 ? (
            <ColumnGroup>
                <Row>
                    <Column footer={<b>Total:</b>} colSpan={1} footerStyle={{ textAlign: 'left' }} />
                    <Column footer={<b>{amountFormate(credit) + '.00'}</b>} />
                    <Column footer={<b>{amountFormate(debit) + '.00'}</b>} />

                    <Column footer={''} colSpan={2} />
                </Row>
            </ColumnGroup>
        ) : (
            <></>
        );
    };

    return (
        <>
            <AccountTabs mainTabLabel="JV Entry" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={jvEntryList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={jvEntryList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Data Found"
                                    footerColumnGroup={footerGroup()}
                                >
                                    {JVEntryListColumns.map((col, i) => {
                                        if (col.field === 'Debit') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={debitTemplate} />;
                                        } else if (col.field === 'Credit') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={creditTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {JVEntryListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
